import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class WizardMenuItem extends Component {
  static propTypes = {
    step: PropTypes.shape({
      name: PropTypes.string.isRequired,
      faIconClass: PropTypes.string,
      path: PropTypes.string,
      accessible: PropTypes.bool.isRequired,
      completed: PropTypes.bool.isRequired,
    }).isRequired,
    onClick: PropTypes.func,
    stepId: PropTypes.number.isRequired,
    isActive: PropTypes.bool.isRequired
  };

  static defaultProps = {
    onClick: null,
  }

  handleOnClick = () => {
    if (!this.isClickable()) { return; }
    this.props.onClick(this.props.stepId);
  };

  isClickable = () => {
    return this.props.step.accessible && this.props.onClick && !this.props.isActive && !this.props.hasErrors;
  }

  render() {
    const { step, stepId, isActive } = this.props;

    const componentClasses = classNames({
      completed: step.completed,
      disabled: !step.accessible,
      active: isActive,
      clickable: this.isClickable(),
    });

    const stepDisplayContent =  step.faIconClass ? <i className={step.faIconClass}></i> : stepId;

    const stepView = step.back ? <i className="fa fa-chevron-left"></i> : stepDisplayContent;

    return (
      <li className={componentClasses} onClick={this.handleOnClick}>
        <div className="step">{stepView}</div>
        <span>{step.name}</span>
      </li>
    );
  }

}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/WizardMenuItem.jsx